import React, { useState } from 'react';
import { DialogTitle, DialogContent } from '@mui/material';
import Input from '../../../PublicSide/components/Input/Input';
import Button from '../../../PublicSide/components/Button/Button';
import SuccessErrorMessage from '../../components/SuccesErrorMessage/SuccessErrorMessage';
import { StyledBox, StyledButtonCancelSubmit, StyledDialogUserServer } from '../../../style/GlobalsComponentsStyled';
import { UserRoleResponse } from '../../../api/dtos/user/UserRoleResponse';

interface AddUserDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (email: string, role: UserRoleResponse) => void;
}

const AddUserDialog: React.FC<AddUserDialogProps> = ({ open, onClose, onSubmit }) => {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<UserRoleResponse>(UserRoleResponse.Employee);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = () => {
    if (!email || !role) {
      setErrorMessage('Please fill in all fields.');
      return
    }
    onSubmit(email, role);
    setEmail('');
    setRole(UserRoleResponse.Employee);
  };

  return (
    <StyledDialogUserServer open={open} onClose={onClose}>
      <StyledBox>
        <DialogTitle>Add New User</DialogTitle>
        <SuccessErrorMessage errorMessage={errorMessage} onClear={() => { setErrorMessage(''); }} sx={{ marginLeft: '10px !important', background: 'rgb(253, 237, 237) !important' }} />
        <DialogContent>
          <StyledBox>
            <Input type='email' label='Email' value={email} onChange={(e) => setEmail(e.target.value)} />
            <Input type='select' label='Role' value={role} onChange={(e) => setRole(e.target.value as UserRoleResponse)} options={['Admin', 'Employee']} />
            <StyledButtonCancelSubmit>
              <Button text='Cancel' onClick={onClose} />
              <Button type='submit' text='Add' onClick={handleSubmit} />
            </StyledButtonCancelSubmit>
          </StyledBox>
        </DialogContent>
      </StyledBox>
    </StyledDialogUserServer>
  );
};

export default AddUserDialog;
